import {
  GET_WP_COLLECT_LIST,
  GET_WP_SETUP_LIST,
  GET_WP_MINE_PAY_LIST,
  SET_WP_MINE_PAY_LIST,
  SET_WP_MINE_SETUP_LIST,
  SET_WP_MINE_COLLECT_LIST,
  GET_WP_VIP_STATE,
  SET_WP_VIP_STATE,
  GET_WP_TURN_LIST,
  SET_WP_TURN_LOAD,
  SET_WP_TURN_LIST,
  GET_WP_GROUP_LIST,
  SET_WP_GROUP_LIST,
  GET_WP_EXCHANGE_RESULT,
  SET_WP_EXCHANGE_RESULT,
} from '../constants/wallpaperPay';
import { takeLatest, put, select, call } from 'redux-saga/effects';
import { createAxios, logNative } from '../utils/utils';

import {
  WP_MINE_PAY_LIST_80,
  WP_MINE_SETUP_80,
  WP_MINE_COLLECTIMG_80,
  WP_VIP_STATE_85,
  WP_CAROUSEL_LIST_85,
  WP_GET_GROUP_LIST_85,
  WP_MINE_PAY_LIST_85,
  WP_EXCHANGE_90,
} from '../config/index';
import { max } from 'lodash-es';

/**
 * 壁纸我的，我购买的壁纸list
 */
function* fetchPayList(params) {
  const info = yield select(state => state.wallpaperPay.minePayInfo);
  yield put({
    type: SET_WP_MINE_PAY_LIST,
    payload: {
      load: true,
    },
  });
  if (params.payload.refresh) {
    yield put({
      type: SET_WP_MINE_PAY_LIST,
      payload: {
        list: [],
        pagenation: {
          goodsType: 'wallpaper',
          appType: '12',
          tagId: params.payload.tagId,
          limit: params.payload.limit,
          skip: params.payload.skip,
          count: 0,
        },
      },
    });
  }
  const axios = yield createAxios('isNeedUser');
  try {
    const res = yield axios.get(WP_MINE_PAY_LIST_85, {
      params: {
        skip: params.payload.skip,
        limit: params.payload.limit,
        goodsType: 'wallpaper',
        appType: '12',
      },
    });
    if (res.data.status === 0) {
      const dataInfo = res.data.data || {};
      const dataList = dataInfo.dataList || [];
      const newList =
        info.tagId === params.tagId && !params.payload.refresh
          ? [...info.list, ...dataList]
          : res.data.data.dataList;
      yield put({
        type: SET_WP_MINE_PAY_LIST,
        payload: {
          list: newList,
          pagenation: {
            tagId: params.payload.tagId,
            limit: params.payload.limit,
            skip: newList.length,
            goodsType: 'wallpaper',
            appType: '12',
            count: res.data.data.count ? +res.data.data.count : 0,
          },
        },
      });
    } else if (res.data.status !== 0 && params.payload.refresh) {
      yield put({
        type: SET_WP_MINE_PAY_LIST,
        payload: {
          list: [],
          pagenation: {
            ...params.payload,
            skip: 0,
            count: 0,
          },
        },
      });
    } else {
      yield put({
        type: SET_WP_MINE_PAY_LIST,
        payload: {
          list: (info && info.list) || [],
          pagenation: {
            ...params.payload,
            skip: 0,
            count: info && info.list && info.list.length,
          },
        },
      });
    }
  } catch (error) {
    logNative(`获取壁纸我的，我使用过的壁纸list fetchSetupList 错误${error}`, error);
  } finally {
    yield put({
      type: SET_WP_MINE_PAY_LIST,
      payload: {
        load: false,
      },
    });
  }
}

/**
 * 壁纸我的，我使用过的壁纸list
 */
function* fetchSetupList(params) {
  const info = yield select(state => state.wallpaperPay.mineSetupInfo);
  yield put({
    type: SET_WP_MINE_SETUP_LIST,
    payload: {
      load: true,
    },
  });
  if (params.payload.refresh) {
    yield put({
      type: SET_WP_MINE_SETUP_LIST,
      payload: {
        list: [],
        pagenation: {
          tagId: params.payload.tagId,
          limit: params.payload.limit,
          skip: params.payload.skip,
          count: 0,
        },
      },
    });
  }
  const axios = yield createAxios('isNeedUser');
  try {
    const res = yield axios.get(WP_MINE_SETUP_80, {
      params: {
        skip: params.payload.skip,
        limit: params.payload.limit,
      },
    });
    if (res.data.status === 0) {
      const setupInfo = res.data.data || {};
      const setupList = setupInfo.wallpapers || [];
      const newList =
        info.tagId === params.tagId && !params.payload.refresh
          ? [...info.list, ...setupList]
          : res.data.data.wallpapers;
      yield put({
        type: SET_WP_MINE_SETUP_LIST,
        payload: {
          list: newList,
          pagenation: {
            tagId: params.payload.tagId,
            limit: params.payload.limit,
            skip: newList.length,
            count: res.data.data.count ? +res.data.data.count : 0,
          },
        },
      });
    } else if (res.data.status !== 0 && params.payload.refresh) {
      yield put({
        type: SET_WP_MINE_SETUP_LIST,
        payload: {
          list: [],
          pagenation: {
            ...params.payload,
            skip: 0,
            count: 0,
          },
        },
      });
    } else {
      yield put({
        type: SET_WP_MINE_SETUP_LIST,
        payload: {
          list: (info && info.list) || [],
          pagenation: {
            ...params.payload,
            skip: 0,
            count: info && info.list && info.list.length,
          },
        },
      });
    }
  } catch (error) {
    logNative(`获取壁纸我的，我使用过的壁纸list fetchSetupList 错误${error}`, error);
  } finally {
    yield put({
      type: SET_WP_MINE_SETUP_LIST,
      payload: {
        load: false,
      },
    });
  }
}

/**
 * 壁纸我的，我喜欢的壁纸list
 */
function* fetchCollectList(params) {
  const info = yield select(state => state.wallpaperPay.mineCollectInfo);
  yield put({
    type: SET_WP_MINE_COLLECT_LIST,
    payload: {
      load: true,
    },
  });
  if (params.payload.refresh) {
    yield put({
      type: SET_WP_MINE_COLLECT_LIST,
      payload: {
        list: [],
        pagenation: {
          tagId: params.payload.tagId,
          limit: params.payload.limit,
          skip: params.payload.skip,
          count: 0,
        },
      },
    });
  }
  const axios = yield createAxios('isNeedUser');
  try {
    const res = yield axios.get(WP_MINE_COLLECTIMG_80, {
      params: {
        skip: params.payload.skip,
        limit: params.payload.limit,
      },
    });
    if (res.data.status === 0) {
      const collectInfo = res.data.data || {};
      const collectList = collectInfo.wallpapers || [];
      const newList =
        info.tagId === params.tagId && !params.payload.refresh
          ? [...info.list, ...collectList]
          : res.data.data.wallpapers;
      yield put({
        type: SET_WP_MINE_COLLECT_LIST,
        payload: {
          list: newList,
          pagenation: {
            tagId: params.payload.tagId,
            limit: params.payload.limit,
            skip: newList.length,
            count: res.data.data.count ? +res.data.data.count : 0,
          },
        },
      });
    } else if (res.data.status !== 0 && params.payload.refresh) {
      yield put({
        type: SET_WP_MINE_COLLECT_LIST,
        payload: {
          list: (res.data.data && res.data.data.wallpapers) || [],
          pagenation: {
            ...params.payload,
            skip: 0,
            count: 0,
          },
        },
      });
    } else {
      const collectList = info.list || [];
      yield put({
        type: SET_WP_MINE_COLLECT_LIST,
        payload: {
          list: collectList || [],
          pagenation: {
            ...params.payload,
            skip: 0,
            count: collectList.length,
          },
        },
      });
    }
  } catch (error) {
    yield put({
      type: SET_WP_MINE_COLLECT_LIST,
      payload: {
        list: [],
        pagenation: {
          ...params.payload,
          skip: 0,
          count: 0,
        },
      },
    });
    logNative(`获取欢壁纸 我的 喜欢数据 fetchCollectList 错误${error}`, error);
  } finally {
    yield put({
      type: SET_WP_MINE_COLLECT_LIST,
      payload: {
        load: false,
      },
    });
  }
}

// 判断两个obj是否一致的函数
function isIdentical(a, b) {
  let value1 = Object.getOwnPropertyNames(a);
  let value2 = Object.getOwnPropertyNames(b);
  if (value1.length != value2.length) {
    return false;
  }
  for (let i = 0, max = value1.length; i < max; i++) {
    let itemName = value1[i];
    if (a[itemName] != b[itemName]) {
      return false;
    }
  }
  return true;
}

// 对比两个对象是否相同
// function equals(a, b) {
//   if (a === b) return true;
//   if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
//   if (!a || !b || (typeof a !== 'object' && typeof b !== 'object')) return a === b;
//   if (a.prototype !== b.prototype) return false;
//   let keys = Object.keys(a);
//   if (keys.length !== Object.keys(b).length) return false;
//   return keys.every(k => equals(a[k], b[k]));
// }

function* fetchVip(params) {
  const vipInfo = yield select(state => state.wallpaperPay.vipState);
  const axios = yield createAxios('isNeedUser');
  try {
    const res = yield axios.get(WP_VIP_STATE_85);
    if (res.data.status === 0) {
      if (!isIdentical(vipInfo, res.data.data)) {
        yield put({
          type: SET_WP_VIP_STATE,
          payload: res.data.data,
        });
      }
    }
  } catch (e) {
    logNative(`获取壁纸vip状态失败`);
  }
}

// 获取轮播列表
function* fetchTurnList(params) {
  const info = yield select(state => state.wallpaperPay.mineTurnInfo);
  if (params.payload.refresh) {
    info.list = [];
    yield put({
      type: SET_WP_TURN_LIST,
      payload: {
        load: true,
        list: [],
        validCarouselList: [],
        invalidCarouselList: [],
      },
    });
  }
  const axios = yield createAxios('isNeedUser');
  try {
    const res = yield axios.get(WP_CAROUSEL_LIST_85, {
      params: { pageCursor: params.payload.pageCursor },
    });
    let turnList = [];
    let vaild = [];
    if (res.data.status === 0) {
      if (res.data.data?.validCarouselList?.length > 0) {
        turnList.push(...res.data.data.validCarouselList);

        if (res.data.data?.invalidCarouselList?.length > 0) {
          turnList = turnList.map(item => {
            return { ...item, vaildType: 'vaild' };
          });

          vaild = vaild.map(item => {
            return { ...item, vaildType: 'vaild' };
          });

          turnList.push(...res.data.data.invalidCarouselList);
        }
      } else {
        if (res.data.data?.invalidCarouselList?.length > 0) {
          turnList.push(...res.data.data.invalidCarouselList);
        }
      }
      let newTurnList = [...info.list, ...turnList];
      let allData = newTurnList
        .filter(item => item.wallpaperInfo !== null)
        .map(el => el.wallpaperInfo);
      yield put({
        type: SET_WP_TURN_LIST,
        payload: {
          load: false,
          list: newTurnList,
          validCarouselList:
            vaild.length > 0
              ? vaild
              : params.payload.refresh
              ? res?.data?.data?.validCarouselList ?? []
              : [...(info?.validCarouselList ?? []), ...(res?.data?.data?.validCarouselList ?? [])],
          invalidCarouselList: params.payload.refresh
            ? res?.data?.data?.invalidCarouselList ?? []
            : [
                ...(info?.invalidCarouselList ?? []),
                ...(res?.data?.data?.invalidCarouselList ?? []),
              ],
          allData: allData,
          pageCursor: res.data.data.pageCursor,
          hasNextPage: res.data.data.hasNextPage,
        },
      });
    }
  } catch (e) {
    yield put({
      type: SET_WP_TURN_LIST,
      payload: {
        load: false,
        list: [],
      },
    });
    logNative(`获取轮播壁纸列表失败`);
  }
}

function* fetchGroupList() {
  yield put({
    type: SET_WP_GROUP_LIST,
    payload: {
      load: true,
    },
  });
  const axios = yield createAxios('isNeedUser');
  try {
    const res = yield axios.get(WP_GET_GROUP_LIST_85);

    if (res?.data?.status === 0) {
      let newArr = [];
      let setup = {};
      let collect = {};
      res.data.data.forEach(item => {
        item.contents.forEach(el => {
          if (el.groupType === '4') {
            collect = { contentId: el.contentId, groupType: el.groupType };
          } else if (el.groupType === '3') {
            setup = { contentId: el.contentId, groupType: el.groupType };
          }
          if (el.hasSelect === 1) {
            newArr.push({ contentId: el.contentId, groupType: el.groupType });
          }
        });
      });
      yield put({
        type: SET_WP_GROUP_LIST,
        payload: {
          load: false,
          list: res.data.data,
          setup,
          collect,
          choiceList: newArr,
        },
      });
    }
  } catch (e) {
    yield put({
      type: SET_WP_GROUP_LIST,
      payload: {
        load: false,
      },
    });
    logNative(`获取轮播壁纸分类列表失败`);
  }
}

function* fetchExchangeResult(params) {
  // yield put({
  //   type: SET_WP_EXCHANGE_RESULT,
  //   payload: {
  //     load: true,
  //     send: 0,
  //   },
  // });
  const axios = yield createAxios('isNeedUser');
  try {
    const res = yield axios.get(WP_EXCHANGE_90, { params: { cdKey: String(params.payload) } });
    if (res?.data?.status === 0) {
      yield put({
        type: SET_WP_EXCHANGE_RESULT,
        payload: {
          load: false,
          resultCode: res?.data?.data,
        },
      });
    } else {
      yield put({
        type: SET_WP_EXCHANGE_RESULT,
        payload: {
          load: false,
          resultCode: '5',
        },
      });
    }
  } catch (err) {
    yield put({
      type: SET_WP_EXCHANGE_RESULT,
      payload: {
        load: false,
        resultCode: '5',
      },
    });
    logNative(`获取壁纸兑换码失败`);
  }
}

// 我的
export function* watchFetchWPCollectListPay() {
  yield takeLatest(GET_WP_COLLECT_LIST, fetchCollectList);
}
export function* watchFetchWPSetupListPay() {
  yield takeLatest(GET_WP_SETUP_LIST, fetchSetupList);
}
export function* watchFetchWPPayListPay() {
  yield takeLatest(GET_WP_MINE_PAY_LIST, fetchPayList);
}
// 获取权益状态
export function* watchFetchWPVip() {
  yield takeLatest(GET_WP_VIP_STATE, fetchVip);
}

// 获取轮播列表
export function* watchFetchTurnList() {
  yield takeLatest(GET_WP_TURN_LIST, fetchTurnList);
}

// 获取分类列表
export function* watchFetchGroupList() {
  yield takeLatest(GET_WP_GROUP_LIST, fetchGroupList);
}

export function* watchFetchExchangeResult() {
  yield takeLatest(GET_WP_EXCHANGE_RESULT, fetchExchangeResult);
}
